import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { Radio } from "@mui/material"
import { AddCircle, Bookmarks, TripOrigin, Menu } from '@mui/icons-material'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { toast } from 'react-toastify'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { FetchApi } from '../../../api/fetch'
import { useAuth } from '../../../contexts/AuthContext'
import { InputField } from '../../../components/InputField'
import { AccordionMain } from '../../../components/accordion'
import Button from '../../../components/Button'
import Modal from '../../../components/Modal'
import VideoSelector from '../../../components/VideoSelector'
import { useApi } from '../../../contexts/ApiContext'
import BtnGradient from '../../../components/GradientButton'
import { ENDPOINT, GO_DE_GQL_BACKEND_URL } from '../../../constants'
import { QUERY_LESSONS} from './query'
import CourseModal from './course-modal'


function Lesson() {
   const { getUserJWT, setIsLoadingOverlayDisplay } = useAuth()

   const { state }: any = useLocation()
   const params: any = useParams()

   const [expanded, setExpanded] = React.useState<string | false>('panel1');
   const [expandedQuestion, setExpandedQuestion] = React.useState<string | false>('quest1');

   const [lessons, setLessons] = useState<any>([])
   const [questions, setQuestions] = useState<any>([])

   const [modal, setModal] = useState<"course" | "connect" | null>(null)
   const [modalCourseId, setModalCourseId] = useState<string>("")

   useEffect(() => {
      getData()
   }, [])

   const getData = async () => {
      await Promise.all([
         getLessons(),
         getQuestions()
      ])
   }

   const getLessons = async () => {
      setIsLoadingOverlayDisplay(true)
      const userJWT = await getUserJWT()

      try {
         const l = await FetchApi({
            endpoint: GO_DE_GQL_BACKEND_URL,
            method: "POST",
            JWT:userJWT,
            body:  ({
               query: QUERY_LESSONS,
               variables: state.ID ? { courseID: state.ID, orderBy: 'createdAt' } : { courseId: params?.course, orderBy: 'createdAt' }
            })
         })
         const d = l?.data?.lesson?.nodes

         if (!d.length || d.length < 1) {
            setLessons([
               {
                  title: "",
                  text: "",
                  media_url: "",
                  media_file: undefined,
                  isUploading: true
               },

            ])
         } else {
            setLessons(d?.sort((a: any, b: any) => a?.position - b?.position))
         }
      } catch (error) {
         // :TODO
         // add error toast
         console.log(error);

      }
      setIsLoadingOverlayDisplay(false)

   }

   const getQuestions = async () => {
      setIsLoadingOverlayDisplay(true)
      const userJWT = await getUserJWT()

      try {

         const l = await FetchApi({
            endpoint: ENDPOINT.BASE_ENDPOINT_ACADEMY + `/${state?.ID ? state?.ID : params?.course}/get-course-questions-data`,
            method: 'POST',
            JWT: userJWT
         })
         const d = l?.data
         if (!d.length || d.length < 1) {
            setQuestions([
               {
                  text: "",
                  answers: [
                     {
                        "text": "",
                        "is_correct": false
                     },
                  ]
               }
            ])
         } else {
            let tempArr = d.map((question: any) => {
               let ans = ""
               let arr = question.Answers.map((answer: any) => {
                  if (question.CorrectID === answer.ID) {
                     ans = answer.Text
                  }
                  // else {
                  //    question.answer = ""
                  // }
                  return { id: answer.ID, text: answer.Text, is_correct: question.CorrectID === answer.ID ? true : false }
               })
               return { id: question.ID, text: question.Text, answer: ans, answers: arr }
            })
            setQuestions(tempArr)
         }
      } catch (error) {
         // :TODO
         // add error toast
         console.log(error);

      }
      setIsLoadingOverlayDisplay(false)

   }
   const saveLessons = async (e: any) => {
      e.preventDefault()
      setIsLoadingOverlayDisplay(true)
      const userJWT = await getUserJWT()
      const n = lessons.map((lesson: any, idx: number) => {
         return { ...lesson, media_url: lesson?.media_url || lesson?.mediaURL, position: idx + 1 }
      });

      const reqBody = {
         id: state?.ID,
         name: state?.Name,
         description: state?.Description,
         project_name: state?.ProjectName,
         project_website: state?.ProjectWebsite,
         number_of_ticket_award: state?.NumberOfTicketAward,
         max_attendees: state?.MaxAttendees,
         start_date: state?.StartDate,
         end_date: state?.EndDate,
         logo_url: state?.LogoURL,
         banner_url: state?.BannerURL,
         position: state.Position,
         featured_position: state?.FeaturedPosition,
         category_id: state?.CategoryIds,
         sub_category_id: state?.SubCategoryIds,
         is_featured: state?.IsFeatured,
         no_max_attendees: state?.NoMaxAttendees,
         no_expiry: state?.NoExpiry,
         time_required: state?.TimeRequired,
      }

      try {
         const data = await FetchApi({
            endpoint: ENDPOINT.BASE_ENDPOINT_ACADEMY + `/${state?.ID}/edit-course`,
            method: `PATCH`,
            JWT: userJWT,

            body:  ({ ...reqBody, lessons: n })
         })

         toast.success(data.message)
         getLessons()
      } catch (error: any) {
         toast.error(error.message)
      }
      setIsLoadingOverlayDisplay(true)

   }

   const saveQuestions = async (e: any) => {
      e.preventDefault()
      setIsLoadingOverlayDisplay(true)
      const userJWT = await getUserJWT()

      const n = lessons.map((lesson: any) => {
         return { id: lesson?.id, media_url: lesson?.media_url || lesson?.mediaURL, title: lesson.title, text: lesson.text }
      });

      let tempArr = questions.map((question: any, questionIdx: number) => {
         question.answers.forEach((answer: any, answerIdx: number) => {
            if (question.answer === answer.text) {
               question.answers[answerIdx].is_correct = true
            } else {
               question.answers[answerIdx].is_correct = false
            }
         })
         return question
      })


      const reqBody = {
         id: state?.ID,
         name: state?.Name,
         description: state?.Description,
         project_name: state?.ProjectName,
         project_website: state?.ProjectWebsite,
         number_of_ticket_award: state?.NumberOfTicketAward,
         max_attendees: state?.MaxAttendees,
         start_date: state?.StartDate,
         end_date: state?.EndDate,
         logo_url: state?.LogoURL,
         banner_url: state?.BannerURL,
         position: state.Position,
         featured_position: state?.FeaturedPosition,
         category_id: state?.CategoryIds,
         sub_category_id: state?.SubCategoryIds,
         is_featured: state?.IsFeatured,
         no_max_attendees: state?.NoMaxAttendees,
         no_expiry: state?.NoExpiry,
         time_required: state?.TimeRequired,
         lessons: n,
         questions: tempArr
      }

      try {
         const data = await FetchApi({
            endpoint: ENDPOINT.BASE_ENDPOINT_ACADEMY + `/${state?.ID}/edit-course`,
            method: `PATCH`,
            JWT: userJWT,
            body:  (reqBody)
         })


         toast.success(data.message)
         getQuestions()
      } catch (error: any) {
         toast.error(error.message)
      }
      setIsLoadingOverlayDisplay(false)
   }


   const addNewQuestion = () => {
      const newOption: any = {
         text: "",
         answers: [
            {
               text: "",
               is_correct: false,
            },
         ]
      }
      const tempArr = questions.concat(newOption)
      setExpandedQuestion(`quest${tempArr.length}`)
      setQuestions(tempArr)
   }

   const addNewLesson = () => {
      const newOption = {
         title: "",
         text: "",
         media_url: "",
         media_file: undefined,
         media_blob: "",
         isUploading: true
      }
      const tempArr = lessons.concat(newOption)
      setExpanded(`panel${tempArr.length}`)
      setLessons(tempArr)
   }

   const openModal = (courseId: string) => {
      setModal("course")
      setModalCourseId(courseId)
   }
   const closeModal = () => {
      setModal(null)
      setModalCourseId("")
   }

   const onDragEnd = (result: any) => {
      // dropped outside the list
      if (!result.destination) {
         return;
      }
      const newItems = [...lessons];
      const [reordered] = newItems.splice(result.source.index, 1);
      newItems.splice(result.destination.index, 0, reordered);
      setLessons(newItems?.map((item, idx) => {
         return { ...item, position: idx + 1 }
      }))
   }

   return (
      <div>
         <div className='w-11/12 m-auto my-10'>
            <div className="sticky mt-0 mb-12 flex flex-row justify-between items-center sm:flex-row">
               <h1 className="font-semibold text-3xl text-left">
                  Lessons
               </h1>

            </div>
            <form onSubmit={saveLessons}>

               <div>
                  <DragDropContext onDragEnd={onDragEnd}>
                     <Droppable droppableId='featured'>
                        {(provided) => (
                           <div
                              className=''
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                           // style={getListStyle(snapshot.isDraggingOver)}
                           >
                              {
                                 lessons.map((lesson: any, lessonIdx: number) => (
                                    <Draggable key={lesson.title + lessonIdx} draggableId={lesson.id || lessonIdx.toString()} index={lessonIdx}>
                                       {(provided) => (
                                          <div
                                             ref={provided.innerRef}
                                             {...provided.draggableProps}
                                             {...provided.dragHandleProps}
                                          >
                                             <LessonForm key={lessonIdx} lesson={lesson} lessonIdx={lessonIdx} lessons={lessons} expanded={expanded} setExpanded={setExpanded} setLessons={setLessons} />

                                          </div>
                                       )}
                                    </Draggable>
                                 ))
                              }
                              {provided.placeholder}
                           </div>
                        )}
                     </Droppable>
                  </DragDropContext>
                  <div className='grid grid-cols-2 gap-4 w-full mt-4'>
                     <button type="submit" id='sub' className="rounded-md text-gray-400 p-2 mb-6 text-sm w-full bg-transparent border border-gray-500 flex items-center justify-center gap-2"><Bookmarks />Save Lessons</button>
                     <button onClick={() => addNewLesson()} type="button" className="rounded-md text-gray-400 p-2 mb-6 text-sm w-full bg-transparent border border-gray-500 flex items-center justify-center gap-2"> <AddCircle /> Add Lesson</button>
                  </div>
               </div>
            </form>
            <form onSubmit={saveQuestions} className='mt-8'>
               <div>
                  <h2 className="mb-4 text-left gradient-text">Create Questions</h2>
                  {
                     questions?.map((question: any, questionIdx: number) => (
                        <QuestionForm key={questionIdx} question={question} questionIdx={questionIdx} questions={questions} expandedQuestion={expandedQuestion} setExpandedQuestion={setExpandedQuestion} setQuestions={setQuestions} />
                     ))
                  }
                  <div>
                  </div>
               </div>

               <div className='grid grid-cols-2 gap-4 w-full mt-4'>

                  <button type="submit" className="rounded-md text-gray-400 p-2 mb-6 text-sm w-full bg-transparent border border-gray-500 flex items-center justify-center gap-2"><Bookmarks /> Save Questions</button>
                  <button onClick={() => addNewQuestion()} type="button" className="rounded-md text-gray-400 p-2 mb-6 text-sm w-full bg-transparent border border-gray-500 flex items-center justify-center gap-2"><AddCircle />Add Question</button>
               </div>
            </form>
            <div>
               <BtnGradient>
                  <Button className='btn bg-transparent' onClick={() => openModal(state.ID)}>
                     Preview
                  </Button>
               </BtnGradient>

            </div>
         </div>
         <CourseModal
            open={modal === "course"}
            onClose={closeModal}
            courseId={modalCourseId}
            lessons={lessons}
            questions={questions}
            onSubmit={() => { }}
         />
      </div>
   )
}

export default Lesson

const LessonForm = ({ lesson, lessons, lessonIdx, expanded, setExpanded, setLessons }: any) => {
   const urlBase = "https://creator-portal-bucket.s3.us-east-2.amazonaws.com"
   const { getUserJWT, setIsLoadingOverlayDisplay } = useAuth()
   const { uploadFile } = useApi()

   const { state }: any = useLocation()
   const params: any = useParams()
   const [deleteInitiated, setDeleteInitiated] = useState<boolean>()
   const [lessonThumbnail, setLessonThumbnail] = useState('')
   const [lessonMediaFile, setLessonMediaFile] = useState<File>()
   const [isLoadingMedia, setisLoadingMedia] = useState(false)
   const [lsns, setlsns] = useState(lesson)
   const clickRef = useRef<any>()

   const handleMediaSelected = async (event: any, idx: number) => {
      let file: File = event?.target?.files && event?.target?.files[0]
      let b;
      let tempArr: any = lessons
      if (file) {
         const reader = new FileReader()
         const filename = `${state.ID || params.course}-${file.name}`
         setLessonMediaFile(file)
         uploadFile(file, filename);
         reader.onload = (e) => {
            b = reader?.result as string
            setLessonThumbnail(b)

            tempArr[idx] = { ...tempArr[idx], media_file: file, media_url: `${urlBase}/${filename}` }
            setlsns({ ...lsns, media_file: file, media_url: `${urlBase}/${filename}` })
            setLessons(tempArr)
         }
         reader.readAsDataURL(file as Blob)
      } else {
         tempArr[idx] = { ...tempArr[idx], media_url: event.target.value }
         setlsns({ ...lsns, media_url: event.target.value })
         setLessonThumbnail('')
         setLessons(tempArr)
      }

   }


   const handleLessonChange = async (e: any, idx: number) => {
      const name = e.target.name;
      const val = e.target.value;
      let tempArr: any = lessons


      if (name === "media_url") {
         await handleMediaSelected(e, idx)

      } else {
         tempArr[idx][name] = val;
         setlsns({ ...lsns, [name]: val })
         setLessons(tempArr)
      }
   }


   const onSelectMedia = () => {
      setisLoadingMedia(true)
      clickRef.current.click()
   }


   const handleClose = () => {
      setDeleteInitiated(false)
   }
   const onDelete = () => {
      setDeleteInitiated(true)
   }
   const onDeleteLesson = async (e: any) => {
      e.preventDefault()

      if (lesson.id) {
         setIsLoadingOverlayDisplay(true)
         const userJWT = await getUserJWT()
         try {
            const data = await FetchApi({
               endpoint: ENDPOINT.BASE_ENDPOINT_ACADEMY + `/${lesson.id}/delete-lesson`,
               method: `DELETE`,
               JWT: userJWT,
            })


            toast.success(data.message)
            let tempArr = lessons.filter((item: any, idx: number) => lessonIdx !== idx)
            setLessons(tempArr)
         } catch (error: any) {
            toast.error(error.message)
         }
      } else {
         let tempArr = lessons.filter((item: any, idx: number) => lessonIdx !== idx)
         setLessons(tempArr)
      }
      handleClose()
      setIsLoadingOverlayDisplay(false)
   }

   function countLetters(str: string) {
      // Use a regular expression to match letters and numbers outside of '< >'
      const regex = /<[^>]*>|[a-zA-Z0-9]/g;

      // Extract matched letters and numbers
      const matches: any = str.match(regex);

      // Filter out letters and numbers inside '< >'
      const filteredChars = matches?.filter((match: string) => !match.startsWith('<') || !match.endsWith('>'));

      // Count the remaining letters and numbers
      const count = filteredChars?.length;

      return count ?? 0;
   }


   return (
      <div>
         <AccordionMain
            item={{
               id: `panel${lessonIdx + 1}`,
               heading:
                  <div
                     className='w-full text-sm font-medium text-white flex items-center justify-between' >
                     <div className='flex items-center gap-2'>
                        <Menu className="h-8 text-white" />
                        <span className='block'>Lesson {lessonIdx + 1}</span>
                     </div>
                     <Button type='button' onClick={onDelete} className='py-1 px-3 bg-red-500 font-semibold mx-2 text-xs'>Delete</Button>
                  </div>
               ,
               body:
                  <div className="p-8 bg-transparent">
                     <div className="flex items-center gap-12 mb-8">
                        <div className="w-7/12">
                           <InputField
                              label="Lesson Title"
                              name='title'
                              defaultValue={lsns.title}
                              onChange={(e) => handleLessonChange(e, lessonIdx)}
                              required
                           />
                           {
                              !lessonThumbnail &&
                              <InputField
                                 label="Media URL"
                                 name='media_url'
                                 defaultValue={lsns.media_url || lsns?.mediaURL}
                                 onChange={(e) => handleLessonChange(e, lessonIdx)}
                              />
                           }

                           <div className="mb-4">
                              <label className="flex justify-between text-sm font-base text-gray-300 mb-2 w-full mr-0">
                                 Lesson Text
                                 <span>
                                    {countLetters(lsns?.text)} / 500
                                 </span>
                              </label>

                              <div className="block bg-transparent border-2 border-kyzzen-secondary text-black rounded-lg w-full">
                                 <CKEditor
                                    editor={ClassicEditor}
                                    data={lsns.text}
                                    onChange={(e: any, editor: { getData: () => any }) => {
                                       const name = 'text';
                                       let val = editor.getData();
                                       // if (countLetters(val) > LETTER_COUNT) {
                                       //    return
                                       // }
                                       let tempArr: any = lessons
                                       tempArr[lessonIdx][name] = val;
                                       setlsns({ ...lsns, [name]: val })
                                       setLessons(tempArr)
                                    }}
                                 />

                              </div>

                           </div>
                           {/* <div className="flex justify-start w-full">
                              <div className="w-8">
                                 <InputField
                                    onChange={(e) => handleLessonChange(e, lessonIdx)}
                                    type="checkbox"
                                    checked={lesson.isUploading}
                                    name="isUploading"
                                    className="form-tick h-6 w-6 border-2 border-black disabled:border-gray-300 rounded-md checked:bg-blue-600 checked:border-transparent focus:outline-none mr-3 cursor-pointer"
                                 />
                              </div>
                              <label className="text-md text-left w-full ml-2">Upload File (no existing URL)</label>
                           </div> */}
                        </div>
                        <div className="w-5/12">
                           {/* <IKContext
                              publicKey={process.env.REACT_APP_IMAGEKIT_ENDPOINT}
                              urlEndpoint={process.env.REACT_APP_IMAGEKIT_PUBLICURL}
                              authenticationEndpoint={process.env.REACT_APP_IMAGEKIT_AUTH_ENDPOINT}
                           >
                              <IKUpload
                                 fileName={lessonMediaFile?.name}
                                 onError={onUploadError}
                                 onSuccess={onUploadSuccess}
                                 ref={clickRef}
                                 accept=".png, .jpg, .jpeg, .gif, .mp4, .mov, .ogg"
                                 onChange={(e: any) => handleLessonChange(e, lessonIdx)}
                                 id="mediaUrl"
                                 name="media_url"
                                 style={{ display: "none" }}
                              />
                              <VideoSelector
                                 // iconSrc={Boolean(!lessonThumbnail) && (lesson?.mediaURL || lesson.media_url) ? (lesson?.mediaURL || lesson.media_url) : lessonThumbnail}
                                 iconSrc={Boolean(!lessonThumbnail) ? (lsns.media_url ? lsns.media_url : lsns.mediaURL) : lessonThumbnail}
                                 onSelectIcon={onSelectMedia}
                                 isLoading={isLoadingMedia}
                                 setIsLoading={setisLoadingMedia}
                                 mediaFile={lessonMediaFile}
                              />
                           </IKContext> */}
                           <input
                              style={{ display: "none" }}
                              type="file"
                              accept=".png, .jpg, .jpeg, .gif, .mp4, .mov, .ogg"
                              id="mediaUrl"
                              name="media_url"
                              ref={clickRef}
                              onChange={(e) => handleLessonChange(e, lessonIdx)}
                           />
                           <VideoSelector
                              // iconSrc={Boolean(!lessonThumbnail) && (lesson?.mediaURL || lesson.media_url) ? (lesson?.mediaURL || lesson.media_url) : lessonThumbnail}
                              iconSrc={Boolean(!lessonThumbnail) ? (lsns.media_url ? lsns.media_url : lsns.mediaURL) : lessonThumbnail}
                              onSelectIcon={onSelectMedia}
                              isLoading={isLoadingMedia}
                              setIsLoading={setisLoadingMedia}
                              mediaFile={lessonMediaFile}
                           />

                        </div>
                     </div>
                  </div>
            }}
            isOpen={expanded}
            setIsOpen={setExpanded}
         />

         <Modal show={deleteInitiated} hide={handleClose} sub='Are you sure you want to delete lesson ?'>
            <div className='flex justify-center gap-3 mt-8' >
               <div className=" text-center">
                  <button type='button' onClick={handleClose} className="block bg-gradient rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 text-md text-semibold">
                     <span
                        className="w-36 bg-gray-90 block m-0.5 rounded-lg py-3"
                     >
                        No
                     </span>
                  </button>
               </div>
               <Button
                  type="button"
                  onClick={onDeleteLesson}
                  className="mb-0 sm:mb-2 w-36 btn bg-gradient text-kyzzen-primary rounded-lg font-medium "
               >
                  Yes
               </Button>
            </div>
         </Modal>
      </div>
   )
}

const QuestionForm = ({ question, questions, questionIdx, expandedQuestion, setExpandedQuestion, setQuestions }: any) => {
   const { getUserJWT, setIsLoadingOverlayDisplay } = useAuth()

   const [deleteInitiated, setDeleteInitiated] = useState<boolean>()
   const [selected, setSelected] = useState<boolean>(question.answer)


   const addNewOption = (questionIdx: number) => {
      const newOption = {
         text: "",
         is_correct: false,
      }
      const tempArr: any = questions[questionIdx]?.answers?.concat(newOption)

      let arr = questions?.map((question: any, idx: number) => {
         if (idx === questionIdx) {
            question.answers = tempArr
         }
         return question
      })

      setQuestions(arr)
   }

   const handleQuestionChange = (e: any, questionIdx: number) => {
      const name = e.target.name;
      const val = e.target.value;
      let tempArr: any = questions
      tempArr[questionIdx][name] = val;

      setQuestions(tempArr)

   }
   const handleOptionChange = (e: any, questionIdx: number, optionIdx: number) => {
      let tempArr: any = questions;

      tempArr[questionIdx].answers[optionIdx].text = e.target.value;

      setQuestions(tempArr)
   }

   const handleAnswerChange = (e: any, questionIdx: number) => {
      const val = e.target.value;

      let tempArr: any = questions;

      tempArr[questionIdx].answer = val;

      setQuestions(tempArr)
      setSelected(tempArr[questionIdx].answer)
   }


   const handleClose = () => {
      setDeleteInitiated(false)
   }
   const onDelete = () => {
      setDeleteInitiated(true)
   }
   const onDeleteQuestion = async (e: any) => {
      e.preventDefault()

      if (question.id) {
         setIsLoadingOverlayDisplay(true)
         const userJWT = await getUserJWT()
         try {
            const data = await FetchApi({
               endpoint:ENDPOINT.BASE_ENDPOINT_ACADEMY + `/${question.id}/delete-question`, 
               method: `DELETE`,
               JWT:userJWT,
            })

               toast.success(data.message)
               let tempArr = questions.filter((item: any, idx: number) => questionIdx !== idx)
               setQuestions(tempArr)

         } catch (error: any) {
            toast.error(error.message)
         }
      } else {
         let tempArr = questions.filter((item: any, idx: number) => questionIdx !== idx)
         setQuestions(tempArr)
      }

      handleClose()
      setIsLoadingOverlayDisplay(false)
   }
   return (
      <div>
         <AccordionMain
            item={{
               id: `quest${questionIdx + 1}`,
               heading:
                  <div
                     className='w-full text-sm font-medium text-white flex items-center justify-between' >
                     <span className='block'>Question {questionIdx + 1}</span>
                     <Button type='button' onClick={onDelete} className='py-1 px-3 bg-red-500 font-semibold mx-2 text-xs'>Delete</Button>
                  </div>,

               body:
                  <div className="p-8 bg-transparent">
                     <div key={questionIdx}>
                        <InputField
                           label={`Question`}
                           name='text'
                           placeholder='Enter Question'
                           onChange={(e) => handleQuestionChange(e, questionIdx)}
                           defaultValue={question?.text}
                           required
                        />
                        <div className="mb-4">
                           <label className="inline-block text-sm font-base text-gray-300 mb-4 w-5/6 mr-0">
                              Select Options
                           </label>
                           <div>
                              {
                                 question.answers?.map((option: any, optionIdx: number) => (
                                    <div key={optionIdx} className='flex gap-2 mb-2'>
                                       <Radio
                                          name={question.id + `${questionIdx}`}
                                          value={option.text}
                                          onChange={(e: any) => handleAnswerChange(e, questionIdx)}
                                          checked={selected === option.text}
                                          checkedIcon={<TripOrigin className="text-accent-main" />}
                                          sx={{
                                             color: "#667085",
                                          }}
                                       />

                                       {/* <input type="radio" name={`option${question.id}`} value={option.text} checked={option.text === is_correct} onChange={(e) => handleAnswerChange(e, questionIdx, optionIdx)} /> */}
                                       <input
                                          className=' w-full text-sm bg-transparent outline-none placeholder-gray-200 text-gray-100'
                                          placeholder='Type here ....'
                                          type="text"
                                          name="text"
                                          defaultValue={option.text}
                                          onChange={(e) => handleOptionChange(e, questionIdx, optionIdx)}
                                       />
                                    </div>
                                 ))
                              }
                              <button onClick={() => addNewOption(questionIdx)} type="button" className='text-sm mt-2 text-gray-500'>Add new option</button>
                           </div>
                        </div>
                     </div>
                  </div>
            }}
            isOpen={expandedQuestion}
            setIsOpen={setExpandedQuestion}
         />

         <Modal show={deleteInitiated} hide={handleClose} sub='Are you sure you want to delete question ?'>
            <div className='flex justify-center gap-3 mt-8'>
               <div className=" text-center">
                  <button type='button' onClick={handleClose} className="block bg-gradient rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 text-md text-semibold">
                     <span
                        className="w-36 bg-gray-90 block m-0.5 rounded-lg py-3"
                     >
                        No
                     </span>
                  </button>
               </div>
               <Button
                  type="button"
                  onClick={onDeleteQuestion}
                  className="mb-0 sm:mb-2 w-36 btn bg-gradient text-kyzzen-primary rounded-lg font-medium "
               >
                  Yes
               </Button>
            </div>
         </Modal>
      </div>
   )
}
